exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-price-schedule-container[data-v-463b1626]{color:#363636}.modal-title[data-v-463b1626]{font-size:20px;font-weight:700;margin-bottom:36px}.grid-schedule[data-v-463b1626]{display:grid;grid-template-columns:60px 80px 80px 200px 100px 150px 120px;grid-gap:20px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.divider[data-v-463b1626]{width:100%;height:1px;background-color:#eee;margin:12px 0}.grid-title[data-v-463b1626]{font-size:14px}", ""]);

// exports
